import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import two_happy_woman from "../../../images/two_happy_woman.jpg";
import two_happy_face from "../../../images/tewo_woman_face.jpg";
import { EmotionPredictionTable, EmotionPredictionList } from '../../PredictionResultTable/PredictionResultTable';
import { motion } from "framer-motion";
import ai_analysis from "../../../images/Emotion_analysis.png";
import discussion from "../../../images/discussion.png";
import ai_thinking from "../../../images/AI_thinking.png";
import ai_idea from "../../../images/ai_idea.png";

import { useState } from "react";

export default function StudyOneInstructionPageTwo(){
        const googleDriveVideoIds = ["1fDEN9qHxWNOvcj8Mj6lN77iQ_jS7BLJ3",
    ];
    const [loading1, setLoading1] = useState(false);
    const [connecting1, setConnecting1] = useState(false);
    const [result1, setResult1] = useState(null);

    const [loading2, setLoading2] = useState(false);
    const [connecting2, setConnecting2] = useState(false);
    const [result2, setResult2] = useState(null);

    const handleAnalyzeClick1 = () => {
        setConnecting1(true);
        setResult1(null);

        
        setTimeout(() => {
            setConnecting1(false);
            setLoading1(true);

            setTimeout(() => {
                setLoading1(false);
                setResult1("Happy : 36.7%");
            }, 1500);
        }, 2000);
    };

    const handleAnalyzeClick2 = () => {
        setConnecting2(true);
        setResult2(null);

        setTimeout(() => {
            setConnecting2(false);
            setLoading2(true);

            setTimeout(() => {
                setLoading2(false);
                setResult2("Happy : 99.8%");
            }, 1500);
        }, 2000);
    };
    const [showBubble, setShowBubble] = useState(false);

    const handleImageClick = () => {
        setShowBubble(true);
    };
    return (
        <Container className="study-item">
            <Row>
                <h1 style={{ fontWeight: 'bold'}}>What's her emotion?</h1>
                <br /><br /><br />
                <Container style={{width:"90%"}}>
                        <Row className="align-items-start mb-4">
                                <Col xs={4} className="text-center">
                                    <img 
                                        src={ai_analysis} 
                                        alt="FEAI icon" 
                                        style={{ width: "200px", height: "200px", }} 
                                    />
                                </Col>
                                <Col xs={6}>
                                <div className="chat-bubble">
                                    <p>
                                    Move our camera to two beautiful ladies!
                                    </p>
                                </div>
                                </Col>
                        </Row> 

                    <Row>
                            {googleDriveVideoIds.map((videoId, index) => (
                                <Col  className="text-center mb-4 video-wrapper">
                                    <iframe
                                        src={`https://drive.google.com/file/d/${videoId}/preview`}
                                        allow="autoplay"
                                        className="video-iframe"
                                        style={{ width: "100%", height: "auto" }}
                                    ></iframe>
                                </Col>
                            ))}
                        </Row>

                    <Row className="align-items-center" style={{ marginTop: "2rem" }}>
                        <p>Let's focus on one of them! The EmoAI took a screenshot for her!</p>
                        <Col md={6} className="text-center">
                            <img
                                src={two_happy_woman}
                                alt="Emotion Input"
                                style={{ width: "100%", maxWidth: "400px", height: "auto" }}
                            />
                        </Col>
                        <Col md={6} className="text-center">
                            <motion.button 
                                onClick={handleAnalyzeClick1} 
                                disabled={connecting1 || loading1}
                                className="button analyze-button"
                                title="Register Now!"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.8 }}
                            >
                                {connecting1 ? (
                                    <>
                                        <Spinner animation="grow" size="sm" /> Connecting to EmoAI...
                                    </>
                                ) : loading1 ? (
                                    <>
                                        <Spinner animation="border" size="sm" /> Analyzing...
                                    </>
                                ) : (
                                    "Analyze"
                                )}
                            </motion.button>
                            <div style={{ marginTop: "1rem", fontSize: "1.5rem", fontWeight: "bold" }}>
                                {result1 && result1}
                            </div>
                        </Col>
                    </Row>

                   
                    <Row className="align-items-center" style={{ marginTop: "2rem" }}>
                        <p>Move the camera closer......</p>
                        <Col md={6} className="text-center">
                            <img
                                src={two_happy_face}
                                alt="Emotion Input"
                                style={{ width: "100%", maxWidth: "400px", height: "auto" }}
                            />
                        </Col>
                        <Col md={6} className="text-center">
                            
                            <motion.button 
                                onClick={handleAnalyzeClick2}
                                disabled={connecting2 || loading2}
                                className="button analyze-button"
                                title="Register Now!"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.8 }}
                            >
                                {connecting2 ? (
                                    <>
                                        <Spinner animation="grow" size="sm" /> Connecting to EmoAI...
                                    </>
                                ) : loading2 ? (
                                    <>
                                        <Spinner animation="border" size="sm" /> Analyzing...
                                    </>
                                ) : (
                                    "Analyze"
                                )}
                            </motion.button>
                            <div style={{ marginTop: "1rem", fontSize: "1.5rem", fontWeight: "bold" }}>
                                {result2 && result2}
                            </div>
                        </Col>
                    </Row>
                    <Row className="align-items-start mb-4">
                        <Col xs={7}>
                            <div className="chat-bubble-left">
                            Why there are different? Why did I give different results?
                            </div>
                        </Col>
                        <Col xs={3} className="text-end">
                            <img
                                src={ai_thinking}
                                alt="FEAI icon"
                                style={{ width: "150px", height: "150px", }}
                            />
                        </Col>
                    </Row>
                    <Row className="align-items-start mb-4">
                        <Col xs={4} className="text-center">
                            <img 
                                src={ai_idea} 
                                alt="FEAI icon" 
                                style={{ width: "150px", height: "150px", cursor: "pointer" }} 
                                onClick={handleImageClick}
                            />
                        </Col>
                        <Col xs={7}>
                            {showBubble && (
                                <div className="chat-bubble">
                                    <p>
                                        <strong className="highlight">Background</strong> impacts the results!
                                    </p>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>
            </Row>
        </Container>
    );
};